import LCheckbox from './LCheckbox.vue'

export default (Vue) => {
  Vue.component(LCheckbox.name, LCheckbox)
}
